import React from "react";

import { useTranslation } from "react-i18next";

export default function RecentGames({
	homeTeamEventCount,
	awayTeamEventCount,
}: {
	homeTeamEventCount?: number;
	awayTeamEventCount?: number;
}) {
	const { t } = useTranslation();

	if (!homeTeamEventCount && !awayTeamEventCount) {
		console.error("homeTeamEventCount and awayTeamEventCount are null.");
		return null;
	}

	return (
		<div
			className="card card--raised card--raised--framed card--stats"
			data-type="recent-games"
		>
			<div className="card__header card--stats__header">
				<div className="card__title card__title--base card--stats__heading">
					{t("EVENT.STATISTICS.RECENT_GAMES")}
				</div>
			</div>

			<div className="card--stats__body">
				<div className="card--stats__section">
					<div className="card--stats__row">
						<div className="card--stats__col card--stats__col--left">
							<div className="card--stats__label">
								{t("EVENT.OFFER.COMPETITOR_HOME")}
							</div>
							<div className="u-mar--x--xtny">-</div>
							<div className="card--stats__value u-color--stats--home">
								{homeTeamEventCount}
							</div>
						</div>

						<div className="card--stats__col card--stats__col--right">
							<div className="card--stats__label u-color--stats--away">
								{awayTeamEventCount}
							</div>
							<div className="u-mar--x--xtny">-</div>
							<div className="card--stats__label">
								{t("EVENT.OFFER.COMPETITOR_AWAY")}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
